import { useDevice } from "Hooks/Endpoints";
import React from "react";
import { Button, Table } from "semantic-ui-react";
import ConnectToSelect from "./ConnectToSelect";
import RegionSelect from "./RegionSelect";

type RegionOptionProps = {
  index: Number;
  name: string;
  onRemove: Function;
};

const RegionOption = ({ index, name, onRemove }: RegionOptionProps) => {
  const { devices } = useDevice();
  return (
    <Table.Row key={index.toString()}>
      <Table.Cell singleLine>
        <RegionSelect name={`${name}.option`} required={true} />
      </Table.Cell>
      <Table.Cell singleLine>
        <ConnectToSelect
          label=''
          devices={devices}
          name={`${name}.connectTo`}
        />
      </Table.Cell>
      <Table.Cell textAlign='left'>
        <Button
          basic
          disabled={index === 0}
          color='red'
          type='button'
          icon='delete'
          onClick={() => onRemove()}
        />
      </Table.Cell>
    </Table.Row>
  );
};

export default RegionOption;
